var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"titleContainer",staticClass:"player-title",class:`player-title__${_vm.playerType}`},[_c('div',{ref:"title",staticClass:"player-title__text",class:[
      _vm.playerType ? `player-title__text--${_vm.playerType}` : '',
      _vm.isInitialTitleAnimation ? 'player-title__text--initial-animation' : '',
      _vm.isFinalTitleAnimation ? 'player-title__text--final-animation' : '',
    ],style:({ animationDuration: `${_vm.animationDuration}ms` })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }